import React from 'react';

// Components
import { Flex } from 'antd';
import CustomButton from '../components/CustomButton';
import ShowMessage from '../components/ShowMessage';
import { useNavigate } from 'react-router-dom';
// Assets
import CheckMarkIcon from "../assets/images/check-mark.png";
import ArrowRight from "../assets/images/arrow-right.svg";
const Confirmation = () => {
  const navigate = useNavigate();

//   const main_menu = useSelector((state) => state.menu.items);
// const [routTo , setRoutTo] = useState('')
//   useEffect(() => {
//     if (main_menu && Array.isArray(main_menu) && main_menu.length > 0) {
//       const firstRoute = main_menu.find(item => item.route && typeof item.route === "string");
//       if (firstRoute) {
//         setRoutTo(`${firstRoute.route}`);
//       }
//     }
//   }, [])

  return (
    <>
      {/* <div className="show-message-container"> */}
        <Flex vertical={true} align="center" justify="center">
          <ShowMessage heading="You’re all set!" text="We've connected to your external data sources. A ZoomLogi representative will contact you soon to integrate with your internal system and complete onboarding." icon={CheckMarkIcon}>
              <Flex justify="center">
                <CustomButton  onClick={() => navigate("/shipment")} text="Take me to my portal" width="254px" height="48px" bgColor="#000" color="#fff" fontSize="16px" fontWeight="500" iconPosition="right" image={ArrowRight} gap="14px" />
              </Flex> 
          </ShowMessage>
        </Flex>
      {/* </div> */}
    </>
  );
};

export default Confirmation;
